import { 
  DialogHeader} from '@/components/ui/dialog';
import BrandHeader from '@/components/molecules/BrandHeader/BrandHeader';
import LanguageToggle from '@/components/molecules/LanguageToggle/LanguageToggle';

interface ModalHeaderProps {
  language: string;
  onLanguageToggle: () => void;
  onClose: () => void;
}

const ModalHeader: React.FC<ModalHeaderProps> = ({ 
  language, 
  onLanguageToggle,
}) => (
    <DialogHeader className="flex flex-row items-center justify-between p-4 sm:p-6 border-b">
      <div className="flex-1 flex items-center gap-3 sm:gap-4">
        <BrandHeader />
      </div>
      <div className="flex items-center gap-2 sm:gap-3">
        <LanguageToggle language={language} onToggle={onLanguageToggle} />
      </div>
    </DialogHeader>
  );

export default ModalHeader;